    /** ------ Feedback Send ------- */
    var input = document.getElementById('file_feedback');

    var span = document.getElementById('feedback-count-files');

    function sendFeedbackForm()
    {
        var formWindow = document.querySelector('.modal_window');
        var windowSendStatus = formWindow.querySelector('.modal_window_send_status');
        var formElement = document.querySelector("#form1");
        var formData = new FormData(formElement);
        var modalFormWindow = document.querySelector('.modal-form');

        var title = document.querySelector("#popup-title");
        var description = document.querySelector("#popup-description");

        var modalSendStatusProgressIndicator = document.querySelector("#modal_send_status_progress_indicator");
        var modalSendStatusWarningMessage = document.querySelector("#modal_send_status_warning_message");

        function windowSendStatusModalOpen(message) {
            //body.style.overflow = 'hidden';
            //formWindow.classList.add('visible_form');
            windowSendStatus.style.display = 'block';
            setTimeout(function () {
                //formWindow.style.opacity = '1';
                windowSendStatus.style.opacity = '1';
            }, 100);
            var sendStatusMessage = document.getElementById('modal-send_status_message');
            sendStatusMessage.innerHTML = message;
        }

        var xmlhttp = getXmlHttp();
        xmlhttp.open("POST", '/feedback-ajax');
        //xmlhttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

        xmlhttp.upload.onloadstart = function(event) {
            if(formWindow) {
                windowSendStatusModalOpen('Подождите пожалуйста и не закрывайте эту страницу, пока идёт отправка Ваших файлов.');
            }
        };

        // обработчик для закачки
        xmlhttp.upload.onprogress = function(event) {
            if (filesCount > 0) {
                modalSendStatusWarningMessage.innerHTML = 'Не закрывайте окно и не покидайте страницу, пока идет отправка файлов!';
                modalSendStatusProgressIndicator.innerHTML = Math.round(event.loaded / 1024) + ' / ' + Math.round(event.total / 1024) + ' KB';
            }
        };

        xmlhttp.onload = function() {
            var responseObj = JSON.parse(xmlhttp.responseText);
            if (responseObj.status === false) {

                title.innerHTML = 'Ошибка!';
                title.style.color = 'red';

                description.innerHTML = responseObj.message;
                modalSendStatusProgressIndicator.innerHTML = '';
                modalSendStatusWarningMessage.innerHTML = '';

            } else if(formWindow) {

                title.innerHTML = 'Отлично!';
                title.style.color = '#313131';

                description.innerHTML = 'Всё не так сложно, правда? <br> Оставайтесь на связи, в ближайшее время <br> мы свяжемся с Вами.';

                if (filesCount > 0) {
                    modalSendStatusProgressIndicator.innerHTML = '&nbsp;';
                    modalSendStatusWarningMessage.style.color = 'green';
                    modalSendStatusWarningMessage.innerHTML = 'Файлы успешно отправлены!';
                }

                windowSendStatusModalOpen(responseObj.message);

                function modalFormClose(){
                    if(modalFormWindow) {
                        //body.style.overflow = 'auto';
                        //modalFormWindow.style.opacity = 0;
                        setTimeout(function () {
                            //modalFormWindow.style.display = 'none';
                        });
                    }
                }

                if(responseObj.status){
                    modalFormClose();
                }

                //noinspection JSAnnotator
                function formModalClose() {
                    //body.style.overflow = 'auto';
                    //formWindow.classList.remove('visible_form');
                    windowSendStatus.style.display = 'none';
                    setTimeout(function(){
                        //formWindow.style.opacity = '0';
                        windowSendStatus.style.opacity = '0';
                    }, 100);

                    // Clear inputs
                    if(responseObj.status){
                        // document.getElementById('feedback-count-files').innerHTML = '';
                        document.getElementById("form1").reset();
                        document.getElementById("current_url_feedback").value = window.ABSOLUTE_URL;
                    }
                }
                formWindow.onclick = formModalClose;
            }
        };
        //xmlhttp.send(body);
        xmlhttp.send(formData);
        return false;
    }